import { type Action } from 'redux';

import { type ComplianceModeState } from './Admin/Utils/ComplianceMode/ComplianceModeReducer';
import { complianceModeInitialState, ComplianceModeReducer } from './Admin/Utils/ComplianceMode/ComplianceModeReducer';
import { type MainMenuActionTypes, type MainMenuState } from './MainMenu/reducer';
import { mainMenuInitialState, MainMenuReducer } from './MainMenu/reducer';
import { type CognitoUserState } from './reducers/cognitoUserReducer';
import { cognitoUserInitialState, CognitoUserReducer } from './reducers/cognitoUserReducer';
import { type SupplementalDataSyncState } from './reducers/supplementalDataSyncReducer';
import { supplementalDataSyncInitialState, SupplementalDataSyncReducer } from './reducers/supplementalDataSyncReducer';
import { type SyncState } from './reducers/syncReducer';
import { syncInitialState, SyncReducer } from './reducers/syncReducer';
import { type TlbUserState } from './reducers/tlbUserReducer';
import { tlbUserInitialState, TlbUserReducer } from './reducers/tlbUserReducer';

export type RootState = {
    menu: MainMenuState;
    user: TlbUserState;
    cognitoUser: CognitoUserState;
    sync: SyncState;
    supplementalDataSync: SupplementalDataSyncState;
    complianceMode: ComplianceModeState;
};
export const initialState: RootState = {
    menu: mainMenuInitialState,
    user: tlbUserInitialState,
    cognitoUser: cognitoUserInitialState,
    sync: syncInitialState,
    supplementalDataSync: supplementalDataSyncInitialState,
    complianceMode: complianceModeInitialState,
};

export type RootActionTypes = Action | MainMenuActionTypes;

export const rootReducer = (state: RootState = initialState, action: RootActionTypes): RootState => ({
    menu: MainMenuReducer(state.menu, action),
    user: TlbUserReducer(state.user, action),
    cognitoUser: CognitoUserReducer(state.cognitoUser, action),
    sync: SyncReducer(state.sync, action),
    supplementalDataSync: SupplementalDataSyncReducer(state.supplementalDataSync, action),
    complianceMode: ComplianceModeReducer(state.complianceMode, action),
});
